export default function analyticsPlugin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$track = _ref.track,
      _track = _ref$track === void 0 ? function () {} : _ref$track;

  return {
    commands: {
      track: function track(editor, type, payload) {
        return _track(type, payload);
      }
    }
  };
}